module.exports = __webpack_public_path__ + "img/industrialMechanics.6a9844b1.jpg";